export interface IApplicationState {
    skullReelId: number;
    skullArr: any;
    showSkull: boolean;
    scatterPositions: any;
    cascadeSkull: boolean;
}

const initialState: IApplicationState = {
    skullReelId: -1,
    skullArr: [],
    scatterPositions: [],
    showSkull: false,
    cascadeSkull: false
};

export enum actionTypes {
    SHOW_SKULL = '@@skull/SHOW_SKULL',
    RESET_SKULL_DATA = '@@skull/RESET_SKULL_DATA',
    SET_SKULL_ARRAY = '@@skull/SET_SKULL_ARRAY',
    SET_SCATTER_ARRAY = '@@skull/SET_SCATTER_ARRAY',
    SET_CASCADE_SKULL = '@@skull/SET_CASCADE_SKULL',
}

export function reducer(
    state: IApplicationState = initialState,
    action: any,
): IApplicationState {
    const {skullArr, scatterArr, cascadeSkull} = action;
    switch (action.type) {
        case actionTypes.SHOW_SKULL:
            return {
                ...state, showSkull: true
            };
        case actionTypes.SET_SKULL_ARRAY:
            return {
                ...state, skullArr: skullArr
            };
        case actionTypes.SET_CASCADE_SKULL:
            return {
                ...state, cascadeSkull: cascadeSkull
            };
        case actionTypes.SET_SCATTER_ARRAY:
            return {
                ...state, scatterPositions: scatterArr
            };
        
        case actionTypes.RESET_SKULL_DATA:
            return {
                ...state, showSkull: false
            };
        
        default:
            return state;
    }
}

export const actions = {
    setShowSkull: (): any => ({type: actionTypes.SHOW_SKULL}),
    resetSkullData: (): any => ({type: actionTypes.RESET_SKULL_DATA}),
    setSkullData: (skullArr: any): any => ({type: actionTypes.SET_SKULL_ARRAY, skullArr}),
    setSkullDuringCascade: (cascadeSkull: any): any => ({type: actionTypes.SET_CASCADE_SKULL, cascadeSkull}),
    setScatterPositions: (scatterArr: any): any => ({type: actionTypes.SET_SCATTER_ARRAY, scatterArr}),
};
